export default {
  storageTokenKeyName: 'okta-token-storage',
  userCountryKeyName: 'resto365-country'
}
